export default __webpack_public_path__ + "static/media/office2.fa4858b6.jpg";